export const AFFILIATE_STORAGE_KEY = 'perch_affiliate_attribution';

export interface StoredAttribution {
  affiliateReferralId: string;
  referralCode: string;
  capturedAt: string;
  expiresAt: string;
}

/**
 * Reads the raw referral code from the stored attribution, for GA reporting only.
 * Returns undefined if no attribution is stored or it has expired.
 */
export function getStoredReferralCode(): string | undefined {
  try {
    const stored = localStorage.getItem(AFFILIATE_STORAGE_KEY);
    if (!stored) return undefined;
    const parsed = JSON.parse(stored) as Partial<StoredAttribution>;
    if (!parsed.expiresAt || new Date(parsed.expiresAt) < new Date()) return undefined;
    return parsed.referralCode || undefined;
  } catch {
    return undefined;
  }
}
